import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';
import { TreeNode } from 'primeng/api';

export class StatusCriteria extends FilterCriteria {
  public override title = 'Status';
  public override type: FilterTypes = FilterTypes.Status;
  statusSelection: TreeNode[] = null;

  public override validate(): boolean {
    return this.statusSelection != null && this.statusSelection.length > 0;
  }

  public override toString(): string {
    const s: string = this.statusSelection ? this.statusSelection.map((selection) => selection.label).join(', ') : '<null>';
    return 'Status: ' + s;
  }
}
